import React from "react";
import { useTranslation } from "react-i18next";
import "./help.scss";
import { envDetailsChecker } from "../../utils/utils";

const Help = () => {
  const { t } = useTranslation("help");

  let envData = envDetailsChecker();

  return (
    <div className="helpContainer">
      <div className="topSection">
        <span id="title">{t("help_page_title")}</span>
      </div>

      <div className="middleSection">
        <div className="versionContainer">
          <div className="leftContainer">
            <span id="versionTitle">{t("version_title")}</span>
          </div>

          <div className="rightContainer">
            <span id="separator"> : </span>
            <span id="versionId">{envData.version}</span>
          </div>
        </div>

        <div className="releaseDateContainer">
          <div className="leftContainer">
            <span id="releaseDateTitle">{t("release_date_title")}</span>
          </div>
          <div className="rightContainer">
            <span id="separator"> : </span>
            <span id="versionId">{envData.releaseDate}</span>
          </div>
        </div>
      </div>

      <div className="bottomSection">
        <span id="description">{t("help_page_description")}</span>
      </div>
    </div>
  );
};

export default Help;
